import { FC } from 'react';
import classNames from 'classnames';
import styles from './ListingCardPlaceholder.module.scss';

const ListingCardPlaceholder: FC = () => {
  const className = (c: string) => classNames(styles.placeholder, styles[c]);
  return (
    <div className={styles.root}>
      <div className={styles.image} />
      <div className={styles.container}>
        <div className={className('category')} />
        <div className={className('favorite')} />
      </div>
      <div className={className('headline')} />
      <div className={className('rating')} />
      <div className={className('price')} />
    </div>
  );
};

export default ListingCardPlaceholder;
